import * as yup from "yup";

let createTicketValidationForm = yup.object().shape({
  queue: yup.string().required("Subject is required"),
  priority: yup.string().required("Priority is required"),
  description: yup.string().required("Description is required"),
});
let createSubjectValidationForm = yup.object().shape({
  title: yup.string().required("Tittle is required"),
});
let createNoticeValidationForm = yup.object().shape({
  title: yup.string().required("Tittle is required"),
  content: yup.string().required("Content is required"),
  type: yup.string().required("Type is required"),
});

export {
  createTicketValidationForm,
  createNoticeValidationForm,
  createSubjectValidationForm,
};
